<template>
  <div class="contact infoPage">
    <div class="infoHeader">
      <font-awesome-icon icon="envelope" class="w3-right headerIcon" /><h2>{{$t('app.footer.contact')}}</h2>
    </div>
    <div class="infoText">   
      <p>{{$t('contact.contactIntro')}}</p>

      <div v-if="errorMessage" class="w3-panel errorBox w3-round">
        {{ errorMessage }} 
        <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
      </div>

      <div v-if="infoMessage" class="w3-panel errorBox w3-round">
        {{ infoMessage }} 
        <font-awesome-icon icon="info-circle" class="info w3-right"/>
      </div>

      <div v-if="!infoMessage">
        <div class="input" >
          <div style="flex: 1;"><input id="emailField" v-model="emailInput" class="themeInput" type="text" :placeholder="$t('contact.email')" autofocus></div>
          <div><font-awesome-icon icon="envelope" class="inputImage"/></div>
        </div>        

        <div class="validation">
            <font-awesome-icon v-if="emailValid" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.validEmail')}}
        </div>
        <br/>
        <textarea rows="5" cols="60" name="text" :placeholder="$t('contact.remarks')" v-model="userRemarks"></textarea>

        <div style="flex: 1;">
          {{$t('contact.robotTextStart')}}
          <input id="robotField" v-model="robotInput" class="themeInput short" type="text">
          {{$t('contact.robotTextFinish')}}
        </div>        

        <div class="validation">
            <font-awesome-icon v-if="roboValid" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('contact.robotSecure')}}
        </div>
      
        <div class="buttons">
          <button class="button-default" @click="send">{{$t('contact.send')}}</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
const apiName = 'api';

export default {
  name: 'Contact',
  props: {
    msg: String
  },
  data: function () {
    return {
      emailInput: "",
      errorMessage: "",
      infoMessage:"",
      robotInput: "",
      userRemarks: ""
    }
  },
  computed: {
    emailValid() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.emailInput);
    },
    roboValid() {
      return (this.robotInput == 'zwart' || this.robotInput == 'black');
    }
  },
  methods: {
    send() {
      const myInit = { 
        body: {
          Feedback: this.userRemarks,
          Email: this.emailInput,
          Robo: process.env.VUE_APP_ROBO
        },
        response: false, 
      };
      let that = this;
      var path = "/Management/ProcessFeedback";
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log("Feedback sent." + JSON.stringify(response));
          that.infoMessage = this.$t('contact.sendSucces');
        })
        .catch(error => {
          console.log("Data: " + error.response.data.message);
          that.errorMessage = error.response.data.message;
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.buttons {
  display: flex;
  flex-direction: row-reverse;
}

.errorIcon {
  margin-top: 4px;
}
.info {
  margin-top:4px;
}
.input {
  max-width: 30vw;
}

.short {
  max-width: 80px;
}

/* mobile */
@media screen and (max-width: 600px) {

.contact {
  width: 98vw;
}

}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

.contact {
  width: 60vw;
}

}

/* laptop */
@media screen and (min-width: 1281px) {

.contact {
  width: 50vw;
}

}
</style>
